/**
 * Registers sync handlers for booking actions from the persistent queue.
 * Loaded via `syncQueueBootstrap` before `processQueue` runs.
 */

import { syncQueue, type SyncAction } from '@/services/syncQueue';
import {
  createBooking,
  updateBooking,
  deleteTripBooking,
  reviveBookingUpdateFromQueue,
  reviveManualBookingFromQueueJson,
} from '@/services/bookings';

syncQueue.registerHandler('create_booking', async (action: SyncAction) => {
  const { tripId, userId, tempId, bookingJson } = action.payload as {
    tripId: string;
    userId: string;
    tempId: string;
    bookingJson: string;
  };
  const booking = reviveManualBookingFromQueueJson(bookingJson);
  await createBooking(tripId, userId, booking, { presetBookingId: tempId, bypassOffline: true });
});

syncQueue.registerHandler('update_booking', async (action: SyncAction) => {
  const { tripId, bookingId, updatesJson } = action.payload as {
    tripId: string;
    bookingId: string;
    updatesJson: string;
  };
  const raw = JSON.parse(updatesJson) as Record<string, unknown>;
  const updates = reviveBookingUpdateFromQueue(raw);
  await updateBooking(tripId, bookingId, updates, { bypassOffline: true });
});

syncQueue.registerHandler('delete_booking', async (action: SyncAction) => {
  const { tripId, bookingId } = action.payload as { tripId: string; bookingId: string };
  await deleteTripBooking(tripId, bookingId);
});
